// ============================================================================
// EcgStatusBadge.tsx — единый бейдж статуса разбора ЭКГ (список и карточка).
// ============================================================================

import { ECG_STATUS_LABELS } from '@/lib/ecgStudies';

function statusTone(code: string): string {
    if (code === 'processed') return 'border-emerald-500/40 bg-emerald-500/10 text-emerald-700';
    if (code === 'retake') return 'border-amber-500/50 bg-amber-500/10 text-amber-700';
    return 'border-destructive/40 bg-destructive/10 text-destructive';
}

export function EcgStatusBadge({ code, label }: { code: string; label?: string }) {
    return (
        <span className={`inline-block text-[11px] border rounded px-1.5 py-0.5 ${statusTone(code)}`}>
            {label || ECG_STATUS_LABELS[code] || code || '—'}
        </span>
    );
}
